import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../client";

const BASE_URL = "shared/ServiceCategories";

export const getServiceCategories = createAsyncThunk(
  "ServiceCategories/list",
  async () => (await api.get(BASE_URL)).data,
);

export const getServiceCategory = createAsyncThunk(
  "ServiceCategories/get",
  async (id) => (await api.get(`${BASE_URL}/${id}`)).data,
);

export const saveServiceCategory = createAsyncThunk(
  "ServiceCategories/save",
  async (data) => (await api.post(BASE_URL, data)).data,
);

export const updateServiceCategory = createAsyncThunk(
  "ServiceCategories/update",
  async (data) => (await api.put(`${BASE_URL}/${data.id}`, data)).data,
);

export const deleteServiceCategory = createAsyncThunk(
  "ServiceCategories/delete",
  async (id) => (await api.delete(`${BASE_URL}/${id}`)).data,
);

const addCases = (builder, thunk, onFulfilled) =>
  builder
    .addCase(thunk.pending, (state) => {
      state.isLoading = true;
      state.message = null;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      state.isLoading = false;
      onFulfilled(state, action);
    })
    .addCase(thunk.rejected, (state, action) => {
      state.isLoading = false;
      state.message = action.payload ?? action.error.message;
    });

const initialState = {
  list: [],
  category: null,
  isLoading: false,
  message: null,
};

const slice = createSlice({
  name: "serviceCategories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addCases(builder, getServiceCategories, (state, action) => {
      state.list = action.payload.data;
    });
    addCases(builder, getServiceCategory, (state, action) => {
      state.category = action.payload.data;
    });
    addCases(builder, saveServiceCategory, (state, action) => {
      state.message = action.payload.message;
    });
    addCases(builder, updateServiceCategory, (state, action) => {
      state.message = action.payload.message;
    });
    addCases(builder, deleteServiceCategory, (state, action) => {
      state.message = action.payload.message;
    });
  },
});

export default slice.reducer;
